import { Asset, AssetMetadata } from '@api';
export class LoadAssetDetails {
    public static readonly type = '[Asset] Load Asset Details';

    constructor(
        public edgeDeviceId: string,
        public assetId: string
    ) {}
}

export class LoadAssetCapabilityModel {
    public static readonly type = '[Asset] Load Asset Capability Model';

    constructor(
        public edgeDeviceId: string,
        public assetId: string
    ) {}
}

export class LoadAssetCapabilityModelUserInterface {
    public static readonly type = '[Asset] Load Asset Capability Model User Interface';

    constructor(
        public edgeDeviceId: string,
        public assetId: string
    ) {}
}

export class PushAssetDeviceStatus {
    public static readonly type = '[Asset] Push Device Status';

    constructor(public data: Asset) {}
}

export class SetAssetMetadata {
    public static readonly type = '[Asset] Set Metadata';

    constructor(public assetMetadata: AssetMetadata) {}
}

export class LoadAssetMetadata {
    public static readonly type = '[Asset] Load Asset Metadata';

    constructor(
        public edgeDeviceId: string,
        public assetId: string
    ) {}
}
